export const SvHuman = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58 23H40.3333V62H34.4444V44H28.5556V62H22.6667V23H5V17H58V23ZM31.5 2C33.0618 2 34.5597 2.63214 35.6641 3.75736C36.7685 4.88258 37.3889 6.4087 37.3889 8C37.3889 9.5913 36.7685 11.1174 35.6641 12.2426C34.5597 13.3679 33.0618 14 31.5 14C29.9382 14 28.4403 13.3679 27.3359 12.2426C26.2315 11.1174 25.6111 9.5913 25.6111 8C25.6111 4.67 28.2317 2 31.5 2Z"
        fill="current-color"
      />
    </svg>
  );
};

export const SvMedican = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.5 2C26.6875 2 23.8069 2.73846 21.9758 3.65923C21.0592 4.12077 20.4083 4.60538 19.9706 5.10154C19.5306 5.59769 19.2533 6.32692 19.2533 6.32692C19.1815 6.51226 19.1337 6.70617 19.1112 6.90385L17.8921 22.6977C17.876 22.7946 17.9081 22.9515 17.8921 23.0577L17.75 24.6454C17.7367 24.7889 17.7367 24.9334 17.75 25.0769C17.75 32.6923 23.9375 38.9231 31.5 38.9231C39.0625 38.9231 45.25 32.6923 45.25 25.0769V24.7169C45.2504 24.6931 45.2504 24.6692 45.25 24.6454L43.8888 6.90385C43.8663 6.70617 43.8185 6.51226 43.7467 6.32692C43.7467 6.32692 43.4694 5.59769 43.0294 5.10154C42.5917 4.60308 41.9408 4.11846 41.0242 3.65923C39.1931 2.73615 36.3125 2 31.5 2ZM31.5 38.9231C16.375 38.9231 4 46.0908 4 52.5523V62H59V52.5523C59 46.4138 47.8121 39.6523 33.7206 38.9946C32.9814 38.9455 32.2408 38.9216 31.5 38.9231ZM31.5 6.61538C35.8542 6.61538 38.029 7.30769 38.9479 7.76923C39.255 7.92385 39.2917 7.98385 39.3787 8.05769L40.3092 19.8846C38.2008 20.0138 35.3271 20.4615 31.5 20.4615C27.6729 20.4615 24.8015 20.0138 22.6908 19.8846L23.6213 8.05769C23.706 7.98385 23.745 7.92385 24.0521 7.76923C24.971 7.30769 27.1458 6.61538 31.5 6.61538ZM29.6369 8.92308V11.6646H26.9167V15.4146H29.6392V18.1538H33.3608V15.4123H36.0833V11.6646H33.3608V8.92308H29.6392H29.6369ZM24.625 44.1154L30.4985 57.3846H8.58333V52.5523C8.58333 50.8331 14.4271 45.7977 24.625 44.1154ZM38.375 44.1154C48.5729 45.8 54.4167 50.8331 54.4167 52.5523V57.3846H32.5015L38.375 44.1154Z"
        fill="current-color"
      />
    </svg>
  );
};

export const SvHeart = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5 7C14.1239 7 9.92709 8.73752 6.83274 11.8303C3.73839 14.9231 2 19.1179 2 23.4918C2 24.991 2.27 26.4903 2.66 27.9895H14.9L18.71 17.8846C19.61 15.4858 23.15 15.2459 24.29 17.8846L30.5 33.9865L32.27 29.7286C32.66 28.7391 33.71 27.9895 35 27.9895H61.34C61.73 26.4903 62 24.991 62 23.4918C62 19.1179 60.2616 14.9231 57.1673 11.8303C54.0729 8.73752 49.8761 7 45.5 7C39.92 7 35 9.78861 32 14.0165C29 9.78861 24.08 7 18.5 7ZM5 32.4873C4.20435 32.4873 3.44129 32.8032 2.87868 33.3655C2.31607 33.9278 2 34.6905 2 35.4858C2 36.281 2.31607 37.0437 2.87868 37.606C3.44129 38.1683 4.20435 38.4843 5 38.4843H12.32L29 54.976C32 57.6747 32 57.6747 35 54.976L51.68 38.4843H59C59.7956 38.4843 60.5587 38.1683 61.1213 37.606C61.6839 37.0437 62 36.281 62 35.4858C62 34.6905 61.6839 33.9278 61.1213 33.3655C60.5587 32.8032 59.7956 32.4873 59 32.4873H36.2L33.41 39.3838C32.21 42.4123 28.76 41.9925 27.65 39.4738L21.5 23.4918L18.62 30.4783C18.17 31.6177 17.15 32.4873 15.8 32.4873H5Z"
        fill="current-color"
      />
    </svg>
  );
};
